export const requestNavigation = (location, setLocation) => {
  if (navigator && navigator.permissions && navigator.permissions.query) {
    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      if (result.state == 'granted') {
        setLocation({ ...location, permissionState: result.state });
        getCurrentLocation({ location, setLocation });
      } else if (result.state == 'denied') {
        setLocation({ ...location, permissionState: result.state });
        stateDenied({ location, setLocation });
      } else {
        getCurrentLocation({ location, setLocation });
      }
      result.onchange = () => {
        if (result.state == 'denied') {
          stateDenied({ location, setLocation });
        } else {
          getCurrentLocation({ location, setLocation });
        }
        setLocation({ ...location, permissionState: result.state });
      };
    });
  } else if (navigator.geolocation) {
    setLocation({ ...location });
    getCurrentLocation({ location, setLocation });
  }
};

const getCurrentLocation = ({ location, setLocation }) => {
  navigator &&
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLocation({ ...location, latitude: pos.coords.latitude, longitude: pos.coords.longitude, isPermission: true });
      },
      function error(msg) {
        alert('Please enable your GPS position feature.');
      },
      {
        maximumAge: 10000,
        timeout: 5000,
        enableHighAccuracy: true
      }
    );
};

const stateDenied = ({ location, setLocation }) => {
  setLocation({ ...location, latitude: 43.71579, longitude: -79.52898, isPermission: false });
};
